export default {
  path: 'dashboard',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Dashboard',
      component: () => import('@/views/menus/Dashboard/Index'),
      meta: {
        permission: true
      }
    }
  ]
}
